import logo1Img from "../assets/images/logos/logo1.webp";
import logo2Img from "../assets/images/logos/logo2.png";
import logo3Img from "../assets/images/logos/logo3.png";
import logo4Img from "../assets/images/logos/logo4.png";
import logo5Img from "../assets/images/logos/logo5.webp";
import logo6Img from "../assets/images/logos/logo6.png";
import logo7Img from "../assets/images/logos/logo7.png";
import logo8Img from "../assets/images/logos/logo8.png";
import logo9Img from "../assets/images/logos/logo9.png";
import logo10Img from "../assets/images/logos/logo10.webp";
import logo11Img from "../assets/images/logos/logo11.png";
import logo12Img from "../assets/images/logos/logo12.png";
import FadeInSection from "./FadeInSection";
import BrandSlider from "./BrandSlider";

function Brands() {
	const logoList = [
		{ src: logo1Img, alt: "Procell Therapy logo", className: "img-md" },
		{ src: logo2Img, alt: "Glymed logo", className: "img-sm" },
		{ src: logo3Img, alt: "Circadia logo", className: "img-md" },
		{ src: logo4Img, alt: "KRX logo", className: "img-lg" },
		{ src: logo5Img, alt: "Esthemax logo", className: "img-xl" },
		{ src: logo6Img, alt: "Wella logo", className: "img-md" },
		{ src: logo7Img, alt: "Redken logo", className: "img-md" },
		{ src: logo8Img, alt: "L'Oreal logo", className: "img-sm" },
		{ src: logo9Img, alt: "K18 logo", className: "img-md" },
		{ src: logo10Img, alt: "Amika logo", className: "img-md" },
		{ src: logo11Img, alt: "Great Lengths logo", className: "img-sm" },
		{ src: logo12Img, alt: "Pureology logo", className: "img-xl" },
	];

	return (
		<div className="brands-container">
			<div className="container">
				<FadeInSection animationType="fade-down">
					<h2>Brands We Work With</h2>
					<hr />
					<div className="my-4">
						<BrandSlider logoList={logoList.slice(0, 4)} direction={"left"} />
					</div>
					<div className="mb-4">
						<BrandSlider logoList={logoList.slice(4, 8)} direction={"right"} />
					</div>
					<div>
						<BrandSlider logoList={logoList.slice(8, 12)} direction={"left"} />
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Brands;
